module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_8019.d591244d.png";